import { ConnectButton } from "@rainbow-me/rainbowkit";
import BackIcon from "@/assets/back.png";
import { Box, Button, Flex, Image, Text, useToast } from "@chakra-ui/react";
import OpenEyeIcon from "./assets/openEye.png";
import CloseEyeIcon from "./assets/closeEye.png";
import WalletIcon from "./assets/wallet.png";
import LocalCurrency from "./LocalCurrency";
import { useUserInfo } from "@/context/UserInfo";
const Header = () => {
  const { showBalance, handleShowBalance } = useUserInfo();
  return (
    <Flex
      align={"center"}
      sx={{
        position: "relative",
        width: "100%",
        padding: "20px",
      }}
    >
      <LocalCurrency></LocalCurrency>
      <ConnectButton.Custom>
        {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          authenticationStatus,
          mounted,
        }) => {
          // Note: If your app doesn't use authentication, you
          // can remove all 'authenticationStatus' checks
          const ready = mounted && authenticationStatus !== "loading";
          const connected =
            ready &&
            account &&
            chain &&
            (!authenticationStatus || authenticationStatus === "authenticated");

          return (
            <div
              {...(!ready && {
                "aria-hidden": true,
                style: {
                  opacity: 0,
                  pointerEvents: "none",
                  userSelect: "none",
                },
              })}
              style={{
                marginLeft: "auto",
              }}
            >
              {(() => {
                if (!connected) {
                  return (
                    <button onClick={openConnectModal} type="button">
                      Connect Wallet
                    </button>
                  );
                }

                if (chain.unsupported) {
                  return (
                    <button
                      onClick={openChainModal}
                      type="button"
                      style={{
                        color: "#F13434",
                      }}
                    >
                      Wrong network
                    </button>
                  );
                }

                return (
                  <div style={{ display: "flex", gap: 12 }}>
                    <button
                      // onClick={openChainModal}
                      style={{ display: "flex", alignItems: "center" }}
                      type="button"
                    >
                      {chain.hasIcon && (
                        <div
                          style={{
                            background: chain.iconBackground,
                            width: "",
                            height: "35px",
                            borderRadius: 999,
                            overflow: "hidden",
                            marginRight: 4,
                          }}
                        >
                          {chain.iconUrl && (
                            <img
                              alt={chain.name ?? "Chain icon"}
                              src={chain.iconUrl}
                              style={{ width: "35px", height: "35px" }}
                            />
                          )}
                        </div>
                      )}
                      {/* {chain.name} */}
                    </button>

                    <Image
                      onClick={openAccountModal}
                      src={WalletIcon}
                      sx={{
                        width: "65px",
                        cursor: "pointer",
                      }}
                    ></Image>
                  </div>
                );
              })()}
            </div>
          );
        }}
      </ConnectButton.Custom>
      <Image
        src={showBalance ? OpenEyeIcon : CloseEyeIcon}
        onClick={() => handleShowBalance(!showBalance)}
        sx={{
          width: "24px",
          cursor: "pointer",
          marginLeft: "20px",
        }}
      ></Image>
    </Flex>
  );
};

export default Header;
